import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react'
import { applyCoupon, getComboDetail, getItemDetail, removeCoupon, saveCouponFreeDelivery } from '../../Redux/actions/menu';
import { connect, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import MenuBox from '../Menu/MenuBox';
import ComboMenuBox from '../Menu/ComboMenuBox';
import jwtDecode from 'jwt-decode';
import { useTranslation } from 'react-i18next';
import { hasItemDiscount } from '../../utils/menu.utils';

const CouponCode = (props: any) => {
    const { t } = useTranslation();
    const [couponCode, setCouponCode] = useState('');
    const [itemOpen, setItemOpen] = useState(false);
    const [comboOpen, setComboOpen] = useState(false);
    const [applyDisable, setApplyDisable] = useState(true);
    const [couponCodeDisable, setCouponCodeDisable] = useState(false);
    const [couponSubmitTitle, setCouponSubmitTitle] = useState('Apply');
    const { couponDetails } = useSelector((state: any) => state.menu);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const orderType = useSelector((state: any) => state.payment.orderType);
    const cartData = useSelector((state: any) => state.cart.cartData)   
    const deliveryFee = useSelector((state: any) => state.store.deliveryfee);
    const posFee = useSelector((state: any) => state.store.pos_fee);
    const token = localStorage.getItem("userToken") 
    const userData: any = token ? jwtDecode(token) : null

    const handleCoupon = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.value.includes(' ')) {
            return;
        }
        setCouponCode(e.target.value);
    }

    const removeCoupon = () => {
        setCouponCode('');
        setApplyDisable(false);
        props.removeCoupon()
        toast.success("Coupon Removed Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
        });
    }

    const isGroupLevelCartValidated = (cartData: any, list: any) => {
        const cartItemswithGroups = cartData.length > 0 ? 
            cartData.filter((product: any) => {
                let group_id = product?.item?.item_group_id?.group_id || product?.combo?.group_id?.group_id
                if(list.includes(group_id)) {
                    return product
                }
            })
        : []
        return cartItemswithGroups.length > 0 ? true : false;
    }

    useEffect(()=> {

        if(couponDetails) {
            setCouponCode(couponDetails.coupon_code);
            setCouponSubmitTitle('Remove');
            setCouponCodeDisable(true);
        }
        else {
            setCouponCode('');
            setCouponSubmitTitle('Apply');
            setCouponCodeDisable(false);
        }

    }, [couponDetails])


    useEffect(()=> {
        if(couponCode.length >= 3) {
            setApplyDisable(false);
        } 
        else {
            setApplyDisable(true);
        }
    }, [couponCode]);

    const calcTotal = (data: any) => {
        let sum: any = 0;
        data.forEach((item: any) => {
            sum += (item.updateOnlineItemPrice && item.updateOnlineItemPrice > 0) ? item.updateOnlineItemPrice : Number(item.totalItemPrice);
        });
        return Math.round(sum * 100) / 100;
    };

    const closeItemByButton = () => {
        setItemOpen(false);
        removeCoupon();
    }

    const closeComboByButton = () => {
        setComboOpen(false);
        removeCoupon();
    }

    const autoCloseItem = () => {
        setItemOpen(false);
    }

    const autoCloseCombo = () => {
        setComboOpen(false);
    }

    const submitCoupon = () => {

        if(!token) {
            toast.error(`Please login first to apply coupon`, {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
            });
            return;
        }

        if(!storeSelected) {
            toast.error(`Please select location first`, {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
            });
            return;
        }

        if(couponDetails) {
            removeCoupon();
            return;
        }

        const hasDiscountedItem = (cartData || []).some((item: any) => hasItemDiscount(item));
        if(hasDiscountedItem) {
            toast.error(`Coupon cannot be applied, please remove discounted item(s) from the cart`, {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
            });
            return;
        }

        const data = {
            coupon_code: couponCode,
            store_id: storeSelected?.store_id || "",
            customer_id: userData?.customer?.customer_id || "",
            order_channel: orderType == "Delivery" ? "delivery" : "pickup",
            order_mode: "online",
            cart_total: cartData ? calcTotal(cartData) : 0,
            cart_items: cartData || []
        }
        setApplyDisable(true);
        props.applyCoupon(data, setApplyDisable, useCoupon)
    }

    const useCoupon = (data: any) => {
        const coupon_type = data.coupon_type.type
        const { type: coupon_level, list } = data.coupon_level
        if(data.free_delivery) {
            props.saveCouponFreeDelivery(data.free_delivery);
            setApplyDisable(false);
        }
        else {
            if(coupon_type == "value") {
                let cartTotal = cartData ? calcTotal(cartData) : 0
                if(orderType == "Delivery") {
                    cartTotal += deliveryFee
                }
                if(posFee > 0) {
                    cartTotal += posFee
                }
                if(coupon_type == "value") {
                    if(cartTotal < data.coupon_type.value) {
                        toast.error(`Minimum total of cart should be ${data.coupon_type.value} to apply this coupon.`, {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                        setCouponCode('');
                        setApplyDisable(false);
                        props.removeCoupon()
                        return;
                    }
                }
            }
            if(coupon_level == "group") {
                if(coupon_type == "percent" || coupon_type == "value") {
                    const flag = isGroupLevelCartValidated(cartData, list)
                    if(!flag) {
                        toast.error(`Coupon is not applicable on selected items`, {
                            position: toast.POSITION.TOP_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                        setCouponCode('');
                        setApplyDisable(false);
                        props.removeCoupon()
                        return;
                    }
                }
            }
            if(coupon_type == "combo" || coupon_type == "item") {
                if(coupon_type == "combo") {
                    props.getComboDetail(orderType, data.coupon_type.product_id, ()=> {
                        setComboOpen(true);
                        setApplyDisable(false);
                    });
                }
                if(coupon_type == "item") {
                    props.getItemDetail(orderType, data.coupon_type.product_id, ()=> {
                        setItemOpen(true);
                        setApplyDisable(false);
                    });
                }
            }
            else {
                setApplyDisable(false);
            }
        }
        toast.info("Coupon Applied Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
        });
    }

    return (
        <div className={`basket-items mb-3 ${props.view == "desktop" ? 'coupon-layout' : 'coupon-layout-mob container-fluid'}`}>
            <div className='item-add'>
                <h3>Add Coupon Code</h3>
                <div className='kfc-box-theme'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className='add-to-basket coupon-body'>
                <div className="flex gap-3">
                    <div className="col">
                        <TextField
                            value={couponCode || ""}
                            onChange={handleCoupon}
                            disabled={couponCodeDisable}
                            name="coupon_code"
                            className="field-style coupon-input disable-fields !mt-0"
                            label={t("ENTER_VOUCHER_CODE")}
                            variant="filled"
                            color="error"
                        />
                    </div>
                    <Button
                        onClick={submitCoupon}
                        disabled={applyDisable ? true : false}
                        className={`w-25 ${applyDisable ? "disable-btn" : "able-btn" }`}
                        variant="contained"
                        color="error"
                    >
                        {couponSubmitTitle}
                    </Button>
                </div>    
            </div>
            {itemOpen &&
                <Modal show={itemOpen} onHide={closeItemByButton} backdrop="static" keyboard={false} size="lg" centered>
                    <div className='modal-design'>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <Modal.Header className='p-0 border-0' closeButton />
                    <MenuBox handleClose={autoCloseItem} />
                </Modal>
            }
            {comboOpen &&
                <Modal show={comboOpen} onHide={closeComboByButton} backdrop="static" keyboard={false} size="lg" centered>
                    <div className='modal-design'>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <Modal.Header className='p-0 border-0' closeButton />
                    <ComboMenuBox handleClose={autoCloseCombo} />
                </Modal>
            }
        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        applyCoupon: function (data: any, setDisable?: any, useCoupon?: any) {
            dispatch(applyCoupon(data, setDisable, useCoupon));
        },
        saveCouponFreeDelivery: function (value: any) {
            dispatch(saveCouponFreeDelivery(value));
        },
        removeCoupon: function () {
            dispatch(removeCoupon());
        },
        getItemDetail: (orderType: any, id: any, handleShow: any) => {
            dispatch(getItemDetail(orderType, id, handleShow))
        },
        getComboDetail: (orderType: any, id: any, handleComboOpen: any) => {
            dispatch(getComboDetail(orderType, id, handleComboOpen))
        }
    }
}
export default connect(null, mapDispatchToProps)(CouponCode);
